import React from "react";
import FilterWrapper from "./FilterWrapper";
import { useTranslations } from "next-intl";
import { Input } from "@/components/ui/input";

type Props = {
  icon: React.ReactNode;
  title: string;
  min: number | undefined;
  max: number | undefined;
  setMin: (value: number | undefined) => void;
  setMax: (value: number | undefined) => void;
  clear?: () => void;
  placeholder?: {
    min: string;
    max: string;
  };
  children?: React.ReactNode;
};

const FilterRange: React.FC<Props> = ({
  max,
  min,
  setMax,
  setMin,
  icon,
  title,
  clear,
  placeholder,
  children,
}) => {
  const t = useTranslations("search");
  return (
    <FilterWrapper
      icon={icon}
      title={title}
      clear={clear}
      showClear={min !== undefined || max !== undefined}
    >
      {children}
      <div className="flex flex-row gap-2 items-center w-full justify-between">
        <Input
          type="number"
          min={0}
          aria-label={`${title}: ${t("input.minimum")}`}
          value={min ?? ""}
          onChange={(e) => {
            if (e.target.value === "") {
              setMin(undefined);
              return;
            }

            setMin(e.target.valueAsNumber);
          }}
          placeholder={placeholder ? placeholder.min : t("input.0")}
          className="min-w-0 text-base sm:text-sm"
        />
        <p className="text-sm font-medium">{t("to")}</p>
        <Input
          type="number"
          min={0}
          aria-label={`${title}: ${t("input.maximum")}`}
          value={max ?? ""}
          onChange={(e) => {
            if (e.target.value === "") {
              setMax(undefined);
              return;
            }

            setMax(e.target.valueAsNumber);
          }}
          placeholder={placeholder ? placeholder.max : t("input.no-max")}
          className="min-w-0 text-base sm:text-sm"
        />
      </div>
    </FilterWrapper>
  );
};

export default FilterRange;
